var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.params.image_id || _vm.item.params.image)?_c('ImageAsset',{attrs:{"photo":_vm.item.params}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }